import * as React from "react";
import { cn } from "./utils";

interface SelectFieldsetProps {
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

const SelectFieldset = ({
  label,
  required,
  error,
  children,
  className,
}: SelectFieldsetProps) => {
  return (
    <div className="space-y-1">
      <fieldset
        className={cn(
          "w-full rounded-[0.6rem] border px-3 pt-[4px] pb-[6px]",
          className
        )}
      >
        <legend className="px-1">
          <span className="text-sm font-medium text-gray-700">
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </span>
        </legend>

        <div className="mt-1">{children}</div>
      </fieldset>

      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
};

export { SelectFieldset };
